import store from '@/store'
import {
  constantRoutes,
  componentsMap,
  noSidebarMap
} from '@/router'
import {
  fetch
} from '@/api'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roleValue) {
    return roles.includes(route.meta.roleValue)
  } else {
    return true
  }
}

function getRouteName(route) {
  if (route.component === 'WorkflowMenuDetail') {
    return `WorkflowMenuDetail${route.props()?.id}`
  }
  return route.component === 'Layout' ? route.name.replace(/^\//, '') : route.component
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */

export function filterAsyncRoutes(routes, menu = []) {
  routes.filter(item => !item.disabled && (item.resType === 1 || item.resType === 2)).forEach(route => {
    // resType 菜单类型 1目录 2菜单 3按钮
    // 2023.08.29 写死：添加流程菜单，产品要求
    if (route.resType === 1 && route.path === '/workflow') {
      const workflowSideBarList = store.state.permission.workflowSideBarList.map((item, idx) => {
        return {
          'id': new Date().getTime() + idx, // todo 优化
          'parentId': route.id,
          'resType': 2,
          'path': `menuDetail/${item.flowKey}`,
          'component': 'WorkflowMenuDetail',
          'disabled': 0,
          'hide': 0,
          'meta': {
            'title': item.menuName,
            'icon': item.iconCode
          },
          'outUrl': 0,
          'frontCache': 0,
          'highlightSidebar': '',
          'showInCrumbs': 1,
          'fixedInTagsView': 0,
          'haveChild': false,
          'children': [],
          'props': () => ({
            'id': item.flowKey
          })
        }
      })

      route.children = [].concat(...route.children, ...workflowSideBarList)
    }

    const tmp = {
      ...route,
      component: componentsMap[route.component],
      name: getRouteName(route),
      hidden: Object.prototype.hasOwnProperty.call(route, 'hidden') ? route.hidden : route.hide === 1
    }

    const _meta = Object.prototype.toString.call(route.meta) === '[object Object]' ? route.meta : {}
    // 本地优先级比配置高
    const meta = {
      noCache: route.frontCache !== 1 || false,
      breadcrumb: route.showInCrumbs === 1,
      affix: route.fixedInTagsView === 1,
      ..._meta,
      // noSidebar: noSidebarMap.findIndex(list => list === route.component) !== -1
      noSidebar: route.showSidebar === 0 // 0-隐藏 1-显示
    }

    if (route.highlightSidebar) {
      meta.activeMenu = route.highlightSidebar
    }

    if (route.children) {
      if (route.children.length) {
        if (state.rootMenuStyle === 0) {

        } else {
          tmp.alwaysShow = route.children.every(v => v.hidden) && route.redirect
        }
        // 判断是否是最后一级
        const isLastLevel = route.children.filter(v => v.hide === 0).every(v => !v.haveChild)
        route.children.forEach(v => v.isLastLevel = isLastLevel)

        tmp.children = filterAsyncRoutes(route.children)
      } else {
        delete tmp.children
      }
    }
    menu.push({
      ...tmp,
      meta
    })
  })

  return menu
}

const state = {
  routes: constantRoutes,
  buttonResKey: [],
  addRoutes: [],
  currentRoutes: {},
  firstRoute: {},
  breadcrumbList: [],
  booAddRoutes: false, // 是否获取过路由
  workflowSideBarList: [],
  rootMenuStyle: 1 // 0 顶部 1 侧边
}
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_BUTTON_ROLE_ARRAY: (state, arr) => {
    state.buttonResKey = arr
  },
  SET_CURRENT_ROUTES: (state, routes) => {
    state.currentRoutes = routes
  },
  SET_FIRST_ROUTE(state, val) {
    state.firstRoute = val
  },
  SET_MENU_STYLE(state, val) {
    state.rootMenuStyle = val
  },
  SET_BREADCRUMB_LIST(state, routerList) {
    state.breadcrumbList = routerList
  },
  SET_BOO_ADD_ROUTES(state, val) {
    state.booAddRoutes = val
  },
  SET_WORKFLOW_SIDEBAR_LIST(state, val) {
    state.workflowSideBarList = val
  }
}

const actions = {
  async generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      const {
        detail,
        routerDetails,
        buttonResKey,
        rootMenuStyle
      } = roles
      // 菜单排版风格，写死，竖排
      commit('SET_MENU_STYLE', 1)
      // routerDetails 菜单路由
      const accessedRoutes = filterAsyncRoutes(Array.isArray(routerDetails) ? routerDetails : [])
      commit('SET_ROUTES', accessedRoutes)
      // detail 登录后第一个打开的页面
      commit('SET_FIRST_ROUTE', Object.prototype.toString.call(detail) === '[object Object]' ? detail : {})
      // buttonResKey: 按钮权限key，一维数据，数组中的每一项都是全局唯一
      commit('SET_BUTTON_ROLE_ARRAY', Array.isArray(buttonResKey) ? buttonResKey : [])
      resolve(accessedRoutes)
    })
  },
  // 获取菜单
  getRouterForToken({ commit }) {
    return new Promise(async (resolve) => {
      const data = await fetch('/api/park/res/getRouterForToken', {}, 'get')
      if (data.code === 20000) {
        resolve(data.data)
      } else {
        resolve({})
      }
    })
  },
  // 获取流程菜单列表
  getMenuList({ commit }) {
    return new Promise(async (resolve) => {
      const data = await fetch('/api/activity-api/workbench/getMenuList', {}, 'get')
      if (data.code === 20000) {
        const temp = Array.isArray(data.data) ? data.data : []
        commit('SET_WORKFLOW_SIDEBAR_LIST', temp)
        resolve(temp)
      } else {
        resolve([])
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
